// source: battery_heartbeat_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var page_pb = require('./page_pb.js');
goog.object.extend(proto, page_pb);
goog.exportSymbol('proto.api.BatteryHeartbeatItem', null, global);
goog.exportSymbol('proto.api.GetBatteryHeartbeatByIDRequest', null, global);
goog.exportSymbol('proto.api.GetBatteryHeartbeatByIDResponse', null, global);
goog.exportSymbol('proto.api.GetBatterySoHRequest', null, global);
goog.exportSymbol('proto.api.GetBatterySoHResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.BatteryHeartbeatItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.api.BatteryHeartbeatItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.BatteryHeartbeatItem.displayName = 'proto.api.BatteryHeartbeatItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.GetBatteryHeartbeatByIDRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.api.GetBatteryHeartbeatByIDRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.GetBatteryHeartbeatByIDRequest.displayName = 'proto.api.GetBatteryHeartbeatByIDRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.GetBatteryHeartbeatByIDResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.api.GetBatteryHeartbeatByIDResponse.repeatedFields_, null);
};
goog.inherits(proto.api.GetBatteryHeartbeatByIDResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.GetBatteryHeartbeatByIDResponse.displayName = 'proto.api.GetBatteryHeartbeatByIDResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.GetBatterySoHRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.api.GetBatterySoHRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.GetBatterySoHRequest.displayName = 'proto.api.GetBatterySoHRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.GetBatterySoHResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.api.GetBatterySoHResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.GetBatterySoHResponse.displayName = 'proto.api.GetBatterySoHResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.BatteryHeartbeatItem.prototype.toObject = function(opt_includeInstance) {
  return proto.api.BatteryHeartbeatItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.BatteryHeartbeatItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.BatteryHeartbeatItem.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
vehicleId: jspb.Message.getFieldWithDefault(msg, 2, ""),
vehicleDeviceId: jspb.Message.getFieldWithDefault(msg, 3, ""),
batteryId: jspb.Message.getFieldWithDefault(msg, 4, ""),
batteryAlias: jspb.Message.getFieldWithDefault(msg, 5, ""),
chargerCounter: jspb.Message.getFieldWithDefault(msg, 6, ""),
batteryVoltage: jspb.Message.getFieldWithDefault(msg, 7, ""),
current: jspb.Message.getFieldWithDefault(msg, 8, ""),
batterySoc: jspb.Message.getFieldWithDefault(msg, 9, ""),
batteryTemperature: jspb.Message.getFieldWithDefault(msg, 11, ""),
numberOfCycles: jspb.Message.getFieldWithDefault(msg, 12, ""),
dischargeMofsetState: jspb.Message.getFieldWithDefault(msg, 13, ""),
chargeMofsetState: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.BatteryHeartbeatItem}
 */
proto.api.BatteryHeartbeatItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.BatteryHeartbeatItem;
  return proto.api.BatteryHeartbeatItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.BatteryHeartbeatItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.BatteryHeartbeatItem}
 */
proto.api.BatteryHeartbeatItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleDeviceId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatteryId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatteryAlias(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setChargerCounter(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatteryVoltage(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrent(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatterySoc(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatteryTemperature(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumberOfCycles(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setDischargeMofsetState(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setChargeMofsetState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.BatteryHeartbeatItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.BatteryHeartbeatItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.BatteryHeartbeatItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.BatteryHeartbeatItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVehicleDeviceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBatteryId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBatteryAlias();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getChargerCounter();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBatteryVoltage();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCurrent();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getBatterySoc();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getBatteryTemperature();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getNumberOfCycles();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getDischargeMofsetState();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getChargeMofsetState();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.api.BatteryHeartbeatItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.BatteryHeartbeatItem} returns this
 */
proto.api.BatteryHeartbeatItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vehicle_id = 2;
 * @return {string}
 */
proto.api.BatteryHeartbeatItem.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.BatteryHeartbeatItem} returns this
 */
proto.api.BatteryHeartbeatItem.prototype.setVehicleId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string vehicle_device_id = 3;
 * @return {string}
 */
proto.api.BatteryHeartbeatItem.prototype.getVehicleDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.BatteryHeartbeatItem} returns this
 */
proto.api.BatteryHeartbeatItem.prototype.setVehicleDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string battery_id = 4;
 * @return {string}
 */
proto.api.BatteryHeartbeatItem.prototype.getBatteryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.BatteryHeartbeatItem} returns this
 */
proto.api.BatteryHeartbeatItem.prototype.setBatteryId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string battery_alias = 5;
 * @return {string}
 */
proto.api.BatteryHeartbeatItem.prototype.getBatteryAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.BatteryHeartbeatItem} returns this
 */
proto.api.BatteryHeartbeatItem.prototype.setBatteryAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string charger_counter = 6;
 * @return {string}
 */
proto.api.BatteryHeartbeatItem.prototype.getChargerCounter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.BatteryHeartbeatItem} returns this
 */
proto.api.BatteryHeartbeatItem.prototype.setChargerCounter = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string battery_voltage = 7;
 * @return {string}
 */
proto.api.BatteryHeartbeatItem.prototype.getBatteryVoltage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.BatteryHeartbeatItem} returns this
 */
proto.api.BatteryHeartbeatItem.prototype.setBatteryVoltage = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string current = 8;
 * @return {string}
 */
proto.api.BatteryHeartbeatItem.prototype.getCurrent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.BatteryHeartbeatItem} returns this
 */
proto.api.BatteryHeartbeatItem.prototype.setCurrent = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string battery_soc = 9;
 * @return {string}
 */
proto.api.BatteryHeartbeatItem.prototype.getBatterySoc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.BatteryHeartbeatItem} returns this
 */
proto.api.BatteryHeartbeatItem.prototype.setBatterySoc = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string battery_temperature = 11;
 * @return {string}
 */
proto.api.BatteryHeartbeatItem.prototype.getBatteryTemperature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.BatteryHeartbeatItem} returns this
 */
proto.api.BatteryHeartbeatItem.prototype.setBatteryTemperature = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string number_of_cycles = 12;
 * @return {string}
 */
proto.api.BatteryHeartbeatItem.prototype.getNumberOfCycles = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.BatteryHeartbeatItem} returns this
 */
proto.api.BatteryHeartbeatItem.prototype.setNumberOfCycles = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string discharge_mofset_state = 13;
 * @return {string}
 */
proto.api.BatteryHeartbeatItem.prototype.getDischargeMofsetState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.BatteryHeartbeatItem} returns this
 */
proto.api.BatteryHeartbeatItem.prototype.setDischargeMofsetState = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string charge_mofset_state = 14;
 * @return {string}
 */
proto.api.BatteryHeartbeatItem.prototype.getChargeMofsetState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.BatteryHeartbeatItem} returns this
 */
proto.api.BatteryHeartbeatItem.prototype.setChargeMofsetState = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.GetBatteryHeartbeatByIDRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.api.GetBatteryHeartbeatByIDRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.GetBatteryHeartbeatByIDRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetBatteryHeartbeatByIDRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
batteryId: jspb.Message.getFieldWithDefault(msg, 1, ""),
page: (f = msg.getPage()) && page_pb.PageRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.GetBatteryHeartbeatByIDRequest}
 */
proto.api.GetBatteryHeartbeatByIDRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.GetBatteryHeartbeatByIDRequest;
  return proto.api.GetBatteryHeartbeatByIDRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.GetBatteryHeartbeatByIDRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.GetBatteryHeartbeatByIDRequest}
 */
proto.api.GetBatteryHeartbeatByIDRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatteryId(value);
      break;
    case 2:
      var value = new page_pb.PageRequest;
      reader.readMessage(value,page_pb.PageRequest.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.GetBatteryHeartbeatByIDRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.GetBatteryHeartbeatByIDRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.GetBatteryHeartbeatByIDRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetBatteryHeartbeatByIDRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBatteryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      page_pb.PageRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional string battery_id = 1;
 * @return {string}
 */
proto.api.GetBatteryHeartbeatByIDRequest.prototype.getBatteryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.GetBatteryHeartbeatByIDRequest} returns this
 */
proto.api.GetBatteryHeartbeatByIDRequest.prototype.setBatteryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PageRequest page = 2;
 * @return {?proto.api.PageRequest}
 */
proto.api.GetBatteryHeartbeatByIDRequest.prototype.getPage = function() {
  return /** @type{?proto.api.PageRequest} */ (
    jspb.Message.getWrapperField(this, page_pb.PageRequest, 2));
};


/**
 * @param {?proto.api.PageRequest|undefined} value
 * @return {!proto.api.GetBatteryHeartbeatByIDRequest} returns this
*/
proto.api.GetBatteryHeartbeatByIDRequest.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.api.GetBatteryHeartbeatByIDRequest} returns this
 */
proto.api.GetBatteryHeartbeatByIDRequest.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.api.GetBatteryHeartbeatByIDRequest.prototype.hasPage = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.api.GetBatteryHeartbeatByIDResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.GetBatteryHeartbeatByIDResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.api.GetBatteryHeartbeatByIDResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.GetBatteryHeartbeatByIDResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetBatteryHeartbeatByIDResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
page: (f = msg.getPage()) && page_pb.PageResponse.toObject(includeInstance, f),
batteryHeartbeatsList: jspb.Message.toObjectList(msg.getBatteryHeartbeatsList(),
    proto.api.BatteryHeartbeatItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.GetBatteryHeartbeatByIDResponse}
 */
proto.api.GetBatteryHeartbeatByIDResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.GetBatteryHeartbeatByIDResponse;
  return proto.api.GetBatteryHeartbeatByIDResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.GetBatteryHeartbeatByIDResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.GetBatteryHeartbeatByIDResponse}
 */
proto.api.GetBatteryHeartbeatByIDResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new page_pb.PageResponse;
      reader.readMessage(value,page_pb.PageResponse.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    case 2:
      var value = new proto.api.BatteryHeartbeatItem;
      reader.readMessage(value,proto.api.BatteryHeartbeatItem.deserializeBinaryFromReader);
      msg.addBatteryHeartbeats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.GetBatteryHeartbeatByIDResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.GetBatteryHeartbeatByIDResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.GetBatteryHeartbeatByIDResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetBatteryHeartbeatByIDResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      page_pb.PageResponse.serializeBinaryToWriter
    );
  }
  f = message.getBatteryHeartbeatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.api.BatteryHeartbeatItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional PageResponse page = 1;
 * @return {?proto.api.PageResponse}
 */
proto.api.GetBatteryHeartbeatByIDResponse.prototype.getPage = function() {
  return /** @type{?proto.api.PageResponse} */ (
    jspb.Message.getWrapperField(this, page_pb.PageResponse, 1));
};


/**
 * @param {?proto.api.PageResponse|undefined} value
 * @return {!proto.api.GetBatteryHeartbeatByIDResponse} returns this
*/
proto.api.GetBatteryHeartbeatByIDResponse.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.api.GetBatteryHeartbeatByIDResponse} returns this
 */
proto.api.GetBatteryHeartbeatByIDResponse.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.api.GetBatteryHeartbeatByIDResponse.prototype.hasPage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated BatteryHeartbeatItem battery_heartbeats = 2;
 * @return {!Array<!proto.api.BatteryHeartbeatItem>}
 */
proto.api.GetBatteryHeartbeatByIDResponse.prototype.getBatteryHeartbeatsList = function() {
  return /** @type{!Array<!proto.api.BatteryHeartbeatItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.api.BatteryHeartbeatItem, 2));
};


/**
 * @param {!Array<!proto.api.BatteryHeartbeatItem>} value
 * @return {!proto.api.GetBatteryHeartbeatByIDResponse} returns this
*/
proto.api.GetBatteryHeartbeatByIDResponse.prototype.setBatteryHeartbeatsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.api.BatteryHeartbeatItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.api.BatteryHeartbeatItem}
 */
proto.api.GetBatteryHeartbeatByIDResponse.prototype.addBatteryHeartbeats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.api.BatteryHeartbeatItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.GetBatteryHeartbeatByIDResponse} returns this
 */
proto.api.GetBatteryHeartbeatByIDResponse.prototype.clearBatteryHeartbeatsList = function() {
  return this.setBatteryHeartbeatsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.GetBatterySoHRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.api.GetBatterySoHRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.GetBatterySoHRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetBatterySoHRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
batteryId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.GetBatterySoHRequest}
 */
proto.api.GetBatterySoHRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.GetBatterySoHRequest;
  return proto.api.GetBatterySoHRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.GetBatterySoHRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.GetBatterySoHRequest}
 */
proto.api.GetBatterySoHRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatteryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.GetBatterySoHRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.GetBatterySoHRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.GetBatterySoHRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetBatterySoHRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBatteryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string battery_id = 1;
 * @return {string}
 */
proto.api.GetBatterySoHRequest.prototype.getBatteryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.GetBatterySoHRequest} returns this
 */
proto.api.GetBatterySoHRequest.prototype.setBatteryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.GetBatterySoHResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.api.GetBatterySoHResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.GetBatterySoHResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetBatterySoHResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
batterySoh: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.GetBatterySoHResponse}
 */
proto.api.GetBatterySoHResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.GetBatterySoHResponse;
  return proto.api.GetBatterySoHResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.GetBatterySoHResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.GetBatterySoHResponse}
 */
proto.api.GetBatterySoHResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBatterySoh(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.GetBatterySoHResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.GetBatterySoHResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.GetBatterySoHResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetBatterySoHResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBatterySoh();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
};


/**
 * optional float battery_soh = 1;
 * @return {number}
 */
proto.api.GetBatterySoHResponse.prototype.getBatterySoh = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.api.GetBatterySoHResponse} returns this
 */
proto.api.GetBatterySoHResponse.prototype.setBatterySoh = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


goog.object.extend(exports, proto.api);
